export interface IQueryStringVM{
    key: string;
    value: string;
}

export class QueryStringVM implements IQueryStringVM{
    public key: string;
    public value: string;
}